import React, { memo, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { currentStepSelector, formSummarySelector } from '../../../store/modules/steps/selectors';
import { FormStep, FormStepProps, StepsState } from '../../../model/global';
import CustomFormField from '../../FormControls/CustomFormField';
import { getFormControlInitialState } from '../../utils';
import { CustomFormFieldState } from '../../FormControls/CustomFormField/CustomFormField';
import { stepsActions } from '../../../store/modules/steps/reducer';
import FormStepSummary from '../../StepComponents/FormStepSummary';

const FormSummary: React.FC<FormStepProps> = ({ onStepControlsChange, data: { stepTemplate } }) => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const step = useSelector(currentStepSelector) as FormStep<'main'>
	const summary = useSelector(formSummarySelector) as StepsState['formSummary']
	const stepErrors = summary.validationErrors[step.stepTemplate];

	const fields: {
		termsCheckbox: CustomFormFieldState | undefined,
		privacyCheckbox: CustomFormFieldState | undefined,
	} = useMemo(
		() => {
			return {
				termsCheckbox: getFormControlInitialState('terms_checkbox', step.stepData.fields.main),
				privacyCheckbox: getFormControlInitialState('privacy_checkbox', step.stepData.fields.main),
			}
		},
		[step.stepData.fields.main]
	)

	// initialise the step data once
	useEffect(() => {
		// don't re-init fields
		if (summary.initialized[stepTemplate]) return;

		const initialData: Record<string, CustomFormFieldState> = {};

		// fill in state with initial field values and validity
		for (const [key, element] of Object.entries(fields)) {
			if (!element || !element.name) continue;

			// @todo - use a util for the below, like getFormControlInitialState() ?
			const invalid = element.value === '' && element.required
			initialData[element.name] = {
				name: element.name as string,
				originalField: element.originalField,
				value: element.value,
				required: !!element.required,
				valid: !invalid,
				invalidReason: element.invalidReason || '',
			};
			if (element.originalField.fieldType === 'checkbox') {
				initialData[element.name]['checked'] = !!element.checked
				if (element.required && !element.checked) {
					initialData[element.name]['valid'] = false
				}
			}
		}

		dispatch(stepsActions.initializeStepPayloadValues({
			stepTemplate,
			stepPayload: initialData,
			initialize: true,
		}));


	}, [dispatch, fields, stepTemplate, summary.initialized]);


	const fieldChangeHandler = (event: CustomFormFieldState): void => {

		dispatch(stepsActions.updateStepPayloadValues({
			stepTemplate,
			stepPayload: event,
		}));

	}

	if (!step) return null

	const termsCheckbox = summary.steps[stepTemplate]['terms_checkbox'] ? summary.steps[stepTemplate]['terms_checkbox'] : undefined;
	const privacyCheckbox = summary.steps[stepTemplate]['privacy_checkbox'] ? summary.steps[stepTemplate]['privacy_checkbox'] : undefined;

	return (
		<div className={classes.summaryWrapper}>

			<FormStepSummary/>

			<div className='uk-grid-medium uk-grid uk-grid-stack'>

				{termsCheckbox && <CustomFormField field={termsCheckbox} fieldErrors={stepErrors} onFieldChange={e => fieldChangeHandler(e)}></CustomFormField>}
				{privacyCheckbox && <CustomFormField field={privacyCheckbox} fieldErrors={stepErrors} onFieldChange={e => fieldChangeHandler(e)}></CustomFormField>}

			</div>

		</div>
	);
};

export default memo(FormSummary);

const useStyles = makeStyles((theme) => ({
	summaryWrapper: {
		width: 'fit-content',
		margin: '0 auto',
		// width: '90%',
		// margin: '0 auto',
	},

}));
